import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-italic",
  "use": "icon-italic-usage",
  "viewBox": "-106 0 426 426.66667",
  "content": "<symbol viewBox=\"-106 0 426 426.66667\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-italic\"><path d=\"m192.332031 0h-64c-11.773437 0-21.332031 9.535156-21.332031 21.332031s9.558594 21.335938 21.332031 21.335938h3.949219l-94.828125 341.332031h-15.785156c-11.777344 0-21.335938 9.535156-21.335938 21.332031s9.558594 21.335938 21.335938 21.335938h64c11.773437 0 21.332031-9.539063 21.332031-21.335938s-9.558594-21.332031-21.332031-21.332031h-3.949219l94.828125-341.332031h15.785156c11.777344 0 21.335938-9.539063 21.335938-21.335938s-9.558594-21.332031-21.335938-21.332031zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/italic.svg
// module id = dYCP
// module chunks = 102